import { ENHANCED_MEASURES_CODELIST } from 'client/utils/constants/enhancedMeasures';

function splitEnhancedMeasures (enhancedMeasures) {
    const baseObject = Object.keys(ENHANCED_MEASURES_CODELIST).reduce((acc, value) => {
        acc[value] = [];
        return acc;
    }, {});

    const filteredMeasures = enhancedMeasures.reduce((acc, site) => {
        const codelistedValue = site.sensitiveAssetData.enhancedmeasures;

        const [codelistKey, codelistValue] = Object.entries(ENHANCED_MEASURES_CODELIST).find(([key, value]) => value === codelistedValue) || [null, null];
        if (!codelistValue) {
            acc.proceedWithCautionAssets.push(site);
        } else {
            acc[codelistKey].push(site);
        }
        return acc;
    }, baseObject);

    return filteredMeasures;
    /*
        {
            permissionRequiredAssets: [],
            furtherConsultationAssets: [],
            specialGuidanceAssets: [],
            proceedWithCautionAssets: []
        }
    */
}

export default splitEnhancedMeasures;
